"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCustomerCardsQuery = exports.useGetWalletQuery = exports.paymentsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var paymentsApi = (0, react_1.createApi)({
    reducerPath: "paymentsApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.PAYMENT_ENGINE_URL) !== null && _a !== void 0 ? _a : "", base_query_1.paymentEngineToken),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["Wallet", "Card"],
    endpoints: function (builder) { return ({
        getWallet: builder.query({
            query: function (integrationId) { return ({ url: "v2/wallet", params: { integration_id: integrationId } }); },
            transformResponse: function (response) { var _a, _b; return (_b = (_a = (0, base_query_1.unwrapEnvelope)(response)) === null || _a === void 0 ? void 0 : _a.balance) !== null && _b !== void 0 ? _b : []; },
            providesTags: function (_result, _error, integrationId) { return [{ type: "Wallet", id: integrationId }]; },
        }),
        getCustomerCards: builder.query({
            query: function (integrationId) { return ({ url: "v2/customer/card/list", params: { integration_id: integrationId } }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : []; },
            providesTags: function (_result, _error, integrationId) { return [{ type: "Card", id: integrationId }]; },
        }),
    }); },
});
exports.paymentsApi = paymentsApi;
var useGetWalletQuery = paymentsApi.useGetWalletQuery, useGetCustomerCardsQuery = paymentsApi.useGetCustomerCardsQuery;
exports.useGetWalletQuery = useGetWalletQuery;
exports.useGetCustomerCardsQuery = useGetCustomerCardsQuery;
